import { z } from 'zod';

/* Vocabulário interno fechado: nenhuma mensagem, SQL ou parâmetro do driver cruza
   o contrato. A categoria desconhecida evita adivinhar a causa em produção. */
export const FAQ_SEED_FAILURE_KINDS = [
  'database_missing_table',
  'database_missing_column',
  'database_conflict_target',
  'database_permission',
  'database_authentication',
  'database_constraint',
  'database_unavailable',
  'database_timeout',
  'database_canceled',
  'database_transport',
  'unknown_failure',
] as const;

export type FaqSeedFailureKind = (typeof FAQ_SEED_FAILURE_KINDS)[number];

export const seedFaqFailureDto = z
  .object({
    error: z.literal('faq_seed_failed'),
    failureKind: z.enum(FAQ_SEED_FAILURE_KINDS),
  })
  .strict();
